import { AdminPanelService } from './admin-panel.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { PermissionsService } from '../core/permissions.service';
import { AuthService } from '../core/auth.service';

@Component({
  selector: 'app-admin-panel',
  templateUrl: './admin-panel.component.html',
  styleUrls: ['./admin-panel.component.scss'],
})
export class AdminPanelComponent implements OnInit {
  @ViewChild('adminSidenav') adminSidenav;
  @ViewChild('navClose') navClose;
  @ViewChild('navOpen') navOpen;
  displayDeleteAccountDialog = false;
  private width: number;
  activeSection: string;

  constructor(
    public authService: AuthService,
    public permissionsService: PermissionsService,
    public adminPanelService: AdminPanelService
  ) {}

  ngOnInit() {
    this.activeSection = 'Ustawienia';
  }

  openSection(title) {
    if (this.activeSection === title) {
      this.activeSection = '';
    } else {
      this.activeSection = title;
    }
  }

  closeNavigation() {
    this.adminSidenav.close();
    this.navOpen.nativeElement.style.visibility = 'visible';
  }

  openNavigation() {
    this.adminSidenav.open();
    this.navOpen.nativeElement.style.visibility = 'hidden';
  }

  logout() {
    this.authService.logout();
  }

  closeSideNavIfSmallWidth() {
    this.width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    if (this.width <= 800) {
      this.closeNavigation();
    }
  }
  deleteAccount() {
    this.adminPanelService.deleteAccount().subscribe();
  }
}
